export default "__VITE_ASSET__CYiwRmyF__"